import { useCallback, useRef } from "react";
import { processBatch } from "../process.js";
import type { AppState } from "../state.js";
import type { AppAction } from "./useAppReducer.js";

export function useProcessBatch(
  stateRef: React.RefObject<AppState>,
  dispatch: React.Dispatch<AppAction>,
) {
  const processingRef = useRef(false);

  const startProcessing = useCallback(async () => {
    if (processingRef.current) return;
    processingRef.current = true;

    const state = stateRef.current!;
    const ac = new AbortController();
    dispatch({ type: "START_PROCESSING", abortController: ac });

    try {
      await processBatch(state.inputs, state.logo, state.hashtag, ac.signal, {
        onProgress: (current, total) => {
          dispatch({ type: "UPDATE_PROGRESS", current, total });
        },
        onResult: (r) => {
          dispatch({ type: "ADD_RESULT", result: r });
        },
        onError: (err) => {
          dispatch({ type: "APPEND_ERROR", inputName: err.inputName, message: err.message });
        },
      });
    } catch (err) {
      dispatch({ type: "SET_ERROR", message: `processing failed: ${(err as Error).message}` });
    }

    dispatch({ type: "FINISH_PROCESSING" });
    processingRef.current = false;
  }, [stateRef, dispatch]);

  return { startProcessing };
}
